import React from "react"
import Index from "../Index"
import { contentLayout, modules } from "../../config/pages"
import { useUser } from "../../contexts/UserContext"
import Forbidden from "../Forbidden"

function ViewContacts (){
  const {user} = useUser()
  let view = contentLayout[modules.ContactList]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.ContactList.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.ContactList}></Index>
 )
}

export default ViewContacts
